export default Object.freeze([
	{ label: 'Commercial Sample', value: 'Sample' },
	{ label: 'Document', value: 'Documents' },
	{ label: 'Gift', value: 'Gift' },
	{ label: 'Humanitarian Donation', value: 'HumanitarianDonation' },
	{ label: 'Merchandise', value: 'Merchandise' },
	{ label: 'Returned Goods', value: 'ReturnedGoods' },
	{ label: 'Other', value: 'Other' },
]);
